import InstrumentIcon from "../instrument-icon";
import Big from "big.js";
import Wallet from "../../containers/modals/wallet";
import SvgIcon from "../svg-icon";

const WithdrawDepositToast = props => {

    const {
        title, amount, code
    } = props
    return (
        <div
            id="liveToast2"
            className="toast show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            <div className="toast-header">
                <strong className="me-auto">
                    <SvgIcon id={'wallet'}/>
                    {title}
                </strong>
            </div>
            <div className="toast-body">
                <div className="d-flex align-items-center gap-1">
                    <InstrumentIcon code={code} isSmall noBg/>

                    <span className={"w-100 p-lg-2"}>
                        {Big(amount || 0).toFixed(8)} {title?.toLowerCase()}
                    </span>
                </div>
            </div>
        </div>

    )

}

export default WithdrawDepositToast
